import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import CodeSplitEnvWrapper from '../common/env/CodeSplitEnvWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentsProcessorsWrapper = () => {
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "commerce-hub.processorCards.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "commerce-hub.processorCards.subtitle"
        })
      })]
    }), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
      authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/commerce-hub/InAppPaymentsProcessorsSection`),
      publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/commerce-hub/PublicPaymentsProcessorsSection`)
    })]
  });
};
export default PaymentsProcessorsWrapper;